import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _TerritoryPickerGetter = Getter.of();
export const _TerritoryPickerResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _TerritoryPickerResponse2TerritoryPicker = _Response2ResponseData();
export const _TerritoryPicker2Data = Fold.compose(_TerritoryPickerGetter, Res._Response());
export const _TerritoryPicker2Attributes = Fold.compose(_TerritoryPicker2Data, Lens.prop("attributes"));
export const _TerritoryPicker2Items = Fold.compose(_TerritoryPickerGetter, Res._Rel("items"), Res._ForEach());
export const _TerritoryPicker2SuggestedItem = Fold.compose(_TerritoryPickerGetter, Res._Rel("suggestedItem"));

